import { supabase } from "@/integrations/supabase/client";

const VISITOR_ID_KEY = "cfc_visitor_id";

function getOrCreateVisitorId(): string {
  try {
    let id = localStorage.getItem(VISITOR_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(VISITOR_ID_KEY, id);
    }
    return id;
  } catch {
    return "anonymous-" + Math.random().toString(36).slice(2);
  }
}

export async function trackVisit() {
  try {
    const visitorId = getOrCreateVisitorId();
    const now = new Date();
    const yearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;

    // Skip if we already tracked this month locally
    const lastTracked = localStorage.getItem("cfc_last_tracked_month");
    if (lastTracked === yearMonth) return;

    // Insert (unique constraint will silently ignore duplicates via onConflict)
    await supabase
      .from("site_visits")
      .insert({ visitor_id: visitorId, year_month: yearMonth });

    localStorage.setItem("cfc_last_tracked_month", yearMonth);
  } catch {
    // Silently fail — tracking must never break the site
  }
}
